import { cr } from "fire-wind-water/core";

const URLS = {};
let SURL = {};

function setURL(s) {
  URLS.url = s;
}

function setUploadURL(s) {
  URLS.UploadUrl = s;
}

function setCacheUrl(s) {
  URLS.cacheUrl = s;
}

function setDomain(s) {
  URLS.domain = s;
}

export const rs = {};

function resetURL(sett) {
  SURL = cr.extend(true, {}, sett);
  setUploadURL(SURL.template.api.ungateway.contentUrl);
  setURL(SURL.template.api.gateway.general + "/");
  setCacheUrl(SURL.template.apiCacheUrl);
  setDomain(SURL.domain || SURL.template.cookie.domain || "smarket.net.cn");
}

export { URLS };
export {
  URLS as URL,
  SURL,
  setURL,
  setUploadURL,
  resetURL,
  setDomain,
  setCacheUrl
};
